import { GraphQLResult, GRAPHQL_AUTH_MODE } from '@aws-amplify/api-graphql';
import { useEffect, useState } from 'react';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from '../../app/store';
import { PlayerMode, selectPlayer } from '../../features/player/playerSlice';
import { Localization, selectTheme, showFooter, showLoading, ThemeMode } from '../../features/theme/themeSlice';
import { GenerateGameSessionTokenMutation, SessionManagementMutation } from '../../API';
import { generateGameSessionToken, sessionManagement } from '../../graphql/mutations';
import { API } from 'aws-amplify';
import { Layout } from 'antd';

const PlayPGVirtual = () => {
	const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
	const theme = useAppSelector(selectTheme);
	const player = useAppSelector(selectPlayer);
	const locale: Localization = theme.language as any;
	const languages: any = { it: 'it-IT', en: 'en-US' };
	const language = languages[locale];
	const [gamesession, setGameSession] = useState(null);
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(showFooter(false));
	}, []);
	const closeSession = (sessionToken: string, callback: (result: any) => void) => {
		(async () => {
			const result: GraphQLResult<SessionManagementMutation> = (await API.graphql({
				query: sessionManagement,
				authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
				variables: {
					session: sessionToken,
					oper: 'SESSION_CLOSE'
				}
			})) as GraphQLResult<SessionManagementMutation>;
			if (result.data.sessionManagement) {
				return result.data.sessionManagement;
			} else return null;
		})().then(r => {
			if (callback) {
				callback(r);
			}
		});
	};

	useEffect(() => {
		(async () => {
			try {
				const result: GraphQLResult<GenerateGameSessionTokenMutation> = (await API.graphql({
					query: generateGameSessionToken,
					authMode: player.logged ? GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS : GRAPHQL_AUTH_MODE.AWS_IAM,
					variables: {
						currency: player.account ? player.account.valute : 'EUR',
						lang: language
					}
				})) as GraphQLResult<GenerateGameSessionTokenMutation>;
				//console.log(result);
				dispatch(showLoading(false));

				setGameSession(result.data.generateGameSessionToken);
			} catch (e) {
				console.log(e);
			}
		})();

		return () => {
			if (gamesession) {
				closeSession(gamesession, () => {
					console.log('sessione chiusa');
				});
			}
		};
	}, []);

	return gamesession ? (
			<Layout 
			  className="game hpage"
			  style={{
				padding: "0px 0",
				position: "relative",
				width: "100%",
				
				// overflowX: "hidden"
			  }}>
			  {" "}
			  
				<Layout.Content style={{display: (theme.sidebarStatus && theme.isMobile) ? "none" : "block"}}>
				  <div className="iframe-container">
				  <iframe className='iframepv'
			frameBorder={0}
			style={{
				width:  "100vw",
				position: "absolute",
				height:"100%"
				
			}}
			//src={`https://demo.pgvirtual.pg.company/v-ui/?operator=demo&init_code=ffffffff-ffff-ffff-ffff-ffffffffffaa`}
			src={`https://22q5l36l33.execute-api.eu-west-1.amazonaws.com/?operator=pgcompany&init_code=`+gamesession}
			title="PGVirtual"
		></iframe>
				  </div>
				</Layout.Content>
			</Layout>
		  ) : (
			<div
			  className="game hpage"
			  style={{
				padding: "20px 0",
				position: "relative",
				width: "100%",
			  }}
			>
			 
			</div>

	);
};

export default PlayPGVirtual;
